import Icon1 from "@assets/icons/Icon";
import { Text1, Text2 } from "@components/ui/texts/Texts";
import { useProjectStore } from "@store/projectStore";

function formatFileSize(octets: number): string {
  if (octets < 1024) return `${octets} o`;
  if (octets < 1024 * 1024) return `${(octets / 1024).toFixed(1)} Ko`;
  return `${(octets / (1024 * 1024)).toFixed(1)} Mo`;
}

export default function BibliothequeScreen() {
  const libraryDocuments = useProjectStore((state) => state.libraryDocuments);

  // Only show library documents visible to guests
  const visibleDocs = libraryDocuments.filter((doc) => doc.visible_to_guests);

  return (
    <div className="flex flex-col h-fit pb-96 mt-10 mx-4 lg:ml-10">
      <div className="flex flex-col w-full max-w-400 gap-1 mb-6">
        <Text1>Bibliothèque</Text1>
        <Text2>Retrouvez ici les documents partagés.</Text2>
      </div>

      {/* Shared documents */}
      {visibleDocs.length > 0 && (
        <div className="flex flex-col gap-2 mb-8 max-w-900">
          <div className="text-h2 font-semibold text-neutral-600 mb-1">Documents partagés</div>
          <div className="flex flex-col bg-white rounded-lg border divide-y">
            {visibleDocs.map((doc) => (
              <a
                key={doc.id}
                href={doc.file.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-row items-center px-4 py-3 gap-3 hover:bg-neutral-50 transition-colors"
              >
                <Icon1 name="file" size={20} color="grey" />
                <div className="flex flex-col flex-1 min-w-0">
                  <div className="text-h2 font-medium truncate">{doc.name}</div>
                  <div className="text-h3 text-neutral-400">
                    {formatFileSize(doc.file.octets)}
                  </div>
                </div>
                <Icon1 name="open" size={18} color="grey" />
              </a>
            ))}
          </div>
        </div>
      )}

      {visibleDocs.length === 0 && (
        <div className="text-h2 text-neutral-400 py-8 text-center">
          Aucun document disponible
        </div>
      )}
    </div>
  );
}
